/* unplugin-vue-components disabled */import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=5b951bae&lang=scss"
import "./css//home.scss?vue&type=style&index=1&id=5b951bae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\official-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b951bae"]])

export default __exports__